export const WHEN_TO_USE = `Purpose: build one dataset of a view — the specific components it
starts from and the kinds of components it walks to — either new or as a change to a traversal in
'loadedTraversals'. The dataset starts from the specific components the user names.

Trigger: the user mentions a view in regard to its traversal, asks to edit a displayed dataset,
or asks to visualize a set of components in a view. Examples: "make a view from
Salesforce to the business capabilities it supports", "add the people who own these applications
to the view", "visualize Salesforce, Workday and SAP in a view".

Scope: one dataset per call.
- Several traversals in 'loadedTraversals': change the one the request refers to.
- One traversal in 'loadedTraversals': change it to include everything the request asks for.
- No traversal in 'loadedTraversals': build one new dataset with everything the request asks
  for.`;

export const BUILD_VIEW_DATASET_CONTEXT_DESCRIPTION = `'componentTypeNames' — the component type
names to use in 'componentType', 'sourceTypeOrInstanceName' and 'targetTypeOrInstanceName'.

'loadedTraversals' — the traversals of the view's datasets, in the payload's shape, each with its
'loadedTraversalId'.

'constructedTraversal' — the traversal this command built last, null before the first.`;
